import json from '@/config/index.json'
export default {
    config: {
        baseUrl: json.baseUrl,
        tokenUrl: json.tokenUrl,
        locale: ['en', 'fr', 'nl'].includes(window.location.pathname.split('/')[1]) ? window.location.pathname.split('/')[1] : 'nl',
        mapsKey: json.mapsKey,
    }
}



// WEBPACK FOOTER //
// ./src/config/index.js